<template>
    <Sidebar v-model:visible="showSidebar" :blockScroll="true" :dismissable="!isLoading" position="right"
        class="vehicle-page-flow p-sidebar-sm">
        <template #header="slotProps">
            <p>{{ vehicle.ModelName }}</p>
            <p class="vehicle-page-flow__header-vehicle-trim">{{ vehicle.ModelTrim }}</p>
        </template>
        <FlowSteps :steps="steps.filter(x => x.visible)" :currentStep="currentStep" />
        <!-- STEP 1 -->
        <div v-if="currentStep == 0" class="vehicle-page-flow__content">
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleTestdriveFlowLocationHeadline }}</p>
                <LocationPicker :locations="locations" :pickedLocation="order.location"
                    @locationChange="handleLocationChange" />
                <div>
                    <div v-if="order.location.id == flowConstants.testDriveAtShop && order.location.value == null">
                        <BranchSelector :branchesNodeId="branchesNodeId" :allowedType="2"
                            @changeBranch="handleChangeBranch" />
                    </div>
                    <div class="vehicle-page-flow__department-card"
                        v-if="order.location.id == flowConstants.testDriveAtShop && order.location.value != null && branch != null">
                        <p>{{ branch.name }}</p>
                        <ul>
                            <li>{{ branch.address }}</li>
                            <li>{{ branch.zipCode }} {{ branch.city }}</li>
                            <li v-if="branch.hasCvr">CVR: {{ branch.cvr }}</li>
                            <li v-if="branch.hasPhoneNumber">Telefon: <a :href="`tel:${branch.phoneNumber}`">{{
                                    branch.phoneNumber }}</a>
                            </li>
                            <li v-if="branch.hasEmail">E-mail: <a :href="`mailto:${branch.email}`">{{ branch.email
                                    }}</a>
                            </li>
                        </ul>
                        <Button class="p-button-secondary p-button-outlined p-button-sm"
                            @click="handleLocationChange(locations.find(x => x.id == flowConstants.testDriveAtShop))">{{
                                dictionary.vehicleTestdriveFlowChangeLocationButtonText }}</Button>
                    </div>

                </div>
            </div>
            <p v-if="isLoadingOpeningHours">Indlæser åbningstider...</p>
            <div v-if="openingHours && Object.keys(order.location).length > 0 && !isLoadingOpeningHours">
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleTestdriveFlowDateTimeHeadline }}</p>
                <div>
                    <div class="formgrid grid">
                        <div class="field col-12 sm:col-6">
                            <label for="date">Dato</label>
                            <Calendar v-model="order.date" :minDate="minDate" :maxDate="maxDate" :showIcon="true"
                                :manualInput="false"
                                :disabledDates="formattedOpeningHours?.filter(x => x.isClosed).map(x => x.date)" />
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label for="time">Tidspunkt</label>
                            <Calendar v-model="order.time" :minDate="minTime" :maxDate="maxTime" :showTime="true"
                                :timeOnly="true" :showIcon="true" :stepMinute="15" icon="pi pi-clock"
                                :manualInput="false" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- STEP 2 -->
        <div v-if="currentStep == 1" class="vehicle-page-flow__content">
            <PersonalInformationForm @personalInformationUpdated="handlePersonalInformationUpdate"
                :userModel="personalInformation" :dictionary="dictionary" />
            <FlowNewsletterSignup :dealerId="vehicle.DealerId" :vehicleBrandAlias="vehicle.BrandAlias"
                :selectedShopId="marketingConsent ? marketingConsent.shopId : null"
                @consentChanged="(consent) => { marketingConsent = consent; }">
            </FlowNewsletterSignup>
        </div>
        <!-- STEP 4 -->
        <div v-if="currentStep == 2" class="vehicle-page-flow__content">
            <div>
                <p class="vehicle-page-flow__headline">{{ dictionary.vehicleFlowCommonConfirmHeadline }}</p>
                <div>
                    <div class="vehicle-page-flow__confirm-location">
                        <img :src="order.location.icon.url" :height="order.location.icon.height"
                            :width="order.location.icon.width" alt="" loading="lazy" />
                        <p v-html="order.location.name"></p>
                    </div>
                    <div class="vehicle-page-flow__department-card"
                        v-if="order.location.name == flowConstants.testDriveAtShop && order.location.value != null && branch != null">
                        <p>{{ branch.name }}</p>
                        <ul>
                            <li>{{ branch.department.address }}</li>
                            <li>{{ branch.department.zipCode }} {{ branch.department.city }}</li>
                            <li>CVR: {{ branch.department.cvr }}</li>
                            <li>Telefon: <a :href="`tel:${branch.department.phone}`">{{ branch.department.phone }}</a>
                            </li>
                            <li>E-mail: <a :href="`mailto:${branch.department.email}`">{{ branch.department.email }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div>
                    <div class="formgrid grid">
                        <div v-if="order.date != null" class="field col-12 sm:col-6">
                            <label>Dato</label>
                            <p>{{ order.date.getDate() }}/{{ order.date.getMonth() + 1 }}/{{ order.date.getFullYear() }}
                            </p>
                        </div>
                        <div v-if="order.time != null" class="field col-12 sm:col-6">
                            <label>Tidspunkt</label>
                            <p>{{ order.time.getHours() }}.{{ order.time.getMinutes() }}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <p class="vehicle-page-flow__sub-headline">
                        {{ dictionary.vehicleFlowCommonConfirmPersonalDetailsHeadline }}</p>
                    <div class="formgrid grid">
                        <div class="field col-12 sm:col-6">
                            <label>Fornavn</label>
                            <p>{{ order.firstName }}</p>

                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Efternavn</label>
                            <p>{{ order.lastName }}</p>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Email</label>
                            <p>{{ order.email }}</p>
                        </div>
                        <div class="field col-12 sm:col-6">
                            <label>Telefon</label>
                            <p>{{ order.phone }}</p>
                        </div>
                        <div v-if="order.address != null" class="field col-12 sm:col-6">
                            <label>Vejnavn</label>
                            <p>{{ order.address }}</p>
                        </div>
                        <div v-if="order.country != null" class="field col-12 sm:col-6">
                            <label>Land</label>
                            <p>{{ order.country }}</p>
                        </div>
                        <div v-if="order.city != null" class="field col-12 sm:col-6">
                            <label>By</label>
                            {{ order.city }}
                        </div>
                        <div v-if="order.zipCode != null" class="field col-12 sm:col-6">
                            <label>Postnummer</label>
                            <p>{{ order.zipCode }}</p>
                        </div>
                        <div v-if="marketingConsent" class="field col-12">
                            <label>Nyhedsbrev</label>
                            <p>Du tilmeldes nyhedsbrev for {{
                                marketingConsent.departmentName }}</p>
                        </div>
                        <div class="field-checkbox col-12">
                            <Checkbox name="consent" :binary="true" inputId="consent" v-model="consent" />
                            <label for="consent" v-html="consentText"></label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Step 4 -->
        <div v-if="currentStep == 3" class="vehicle-page-flow__content">
            <div class="vehicle-page-flow__confirmation">
                <img src="/assets/images/checkmark.svg" width="45" height="45" alt="" loading="lazy">
                <div class="rte" v-html="confirmationText"></div>
                <Button class="p-button-secondary  p-button-outlined" @click="endFlow">{{
                    dictionary.vehicleFlowCommonEndFlowButtonText }}</Button>
            </div>
        </div>
        <div v-if="currentStep != 3" class="vehicle-page-flow__navigation">
            <Button class="p-button-secondary" v-if="currentStep == 0"
                :disabled="Object.keys(order.location).length == 0 || (order.location.id == 'Ved lokal afdeling' && order.location.value == null)"
                @click="changeStep(true)" :label="dictionary.vehicleFlowCommonInitButtonText"></Button>
            <Button class="p-button-secondary  p-button-outlined" v-if="currentStep > 0" :disabled="isLoading"
                @click="changeStep(false)" :label="dictionary.vehicleFlowCommonPreviousButtonText"></Button>
            <Button class="p-button-secondary" :disabled="currentStep == 2 && !consent || isLoading"
                v-if="currentStep > 0" @click="changeStep(true)"
                :label="dictionary.vehicleFlowCommonNextButtonText"></Button>
        </div>
        <div v-if="faqItems.length > 0" class="vehicle-page-flow__footer">
            <FlowAccordion :items="faqItems" />
        </div>
    </Sidebar>
    <Toast position="top-center" />
</template>
<script>

import Calendar from 'primevue/calendar';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import Checkbox from 'primevue/checkbox';
import FlowAccordion from './components/flowAccordion.vue';
import FlowSteps from './components/flowSteps.vue';
import Toast from 'primevue/toast';
import VueHelpers from './vueHelpers';
import FlowConstants from './flowConstants';
import BranchSelector from './components/branchSelector.vue';
import LocationPicker from './components/locationPicker.vue';
import Recaptcha from './../partials/recaptcha';
import PersonalInformationForm from './components/personalInformationForm.vue';
import FlowNewsletterSignup from './components/flowNewsletterSignup.vue';
const initContactButtonSelector = ".vehicle-info__book-testdrive-button";

export default {
    name: "testdriveVehicleFlow",
    components: {
        Button,
        Sidebar,
        Checkbox,
        FlowSteps,
        FlowAccordion,
        Toast,
        Calendar,
        BranchSelector,
        LocationPicker,
        PersonalInformationForm,
        FlowNewsletterSignup

    },
    data() {
        return {
            dictionary: [],
            vehicle: null,
            showSidebar: false,
            flowName: "testdriveVehicle",
            steps: [
                { id: 1, name: "Vælg tid og sted", queryAlias: "tid-og-sted", visible: true },
                { id: 2, name: "Information om dig", queryAlias: "information-om-dig", visible: true },
                { id: 3, name: "Bekræft oplysninger", queryAlias: "bekraeft-oplysninger", visible: true },
                { id: 4, name: "Bekræftelse", queryAlias: "bekraeftelse", visible: false }
            ],
            currentStep: 0,
            locations: null,
            culture: "da-DK",
            minDate: new Date(),
            maxDate: new Date(),
            minTime: new Date(),
            maxTime: new Date(),
            faqItems: null,
            branchesNodeId: null,
            consent: false,
            branch: null,
            flowConstants: FlowConstants,
            consentText: "Alle indtastede oplysninger er korrekte og jeg har læst, forstået og accepterer  persondata behandling",
            confirmationText: "",
            marketingConsent: null,
            isSubmitted: false,
            openingHours: null,
            isLoadingOpeningHours: false,
            vehicleBranchOpeningHours: null,
            order: {
                location: {},
                date: null,
                time: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                address: null,
                country: null,
                city: null,
                zipCode: null,
                personalInformationValid: false,
            },
            isLoading: false
        };
    },
    created() {
        const vm = this;
        VueHelpers.clearQueryString();
        vm.consentText = FlowConstants.defaultConsentText;
        vm.vehicle = JSON.parse(vm.$parent.vehicle);
        vm.culture = document.querySelector("html").getAttribute("lang");
        const nodeId = parseInt(vm.$parent.nodeId);
        vm.branchesNodeId = parseInt(vm.$parent.branchesNodeId);

        vm.locations = [
            { id: FlowConstants.testDriveOnLocation, name: vm.vehicle.DealerCity, value: null, icon: { url: "/assets/images/mapmarker.svg", height: 25, width: 18 } },
            { id: FlowConstants.testDriveAtShop, name: "En afdeling nær dig", value: null, icon: { url: "/assets/images/mapmarker.svg", height: 25, width: 18 } }
        ];

        fetch(`/umbraco/api/resourcesApi/GetVehicleTestdriveFlowResources?nodeId=${nodeId}`).then((response) => response.json())
            .then((data) => {
                vm.faqItems = data.faqItems;
                vm.consentText = data.consentText;
                vm.dictionary = data.dictionary;
                vm.confirmationText = data.confirmationText;
            })
            .catch((error) => {
                console.log(error);
            });

        vm.getOpeningHours(vm.vehicle.DealerId, true, true);

    },
    mounted() {
        const vm = this;
        const initContactButtons = document.querySelectorAll(initContactButtonSelector);
        if (initContactButtons) {
            initContactButtons.forEach(button => {
                button.addEventListener('click', e => {
                    vm.initFlow();
                });
            });
        }
    },
    watch: {
        'order.date'() {
            this.setDateTimeBorders();
            this.order.time = this.minTime;
        }
    },
    methods: {
        async getOpeningHours(dealerId, isSettingDefault = false, adjustBorders = false) {
            const vm = this;
            vm.isLoadingOpeningHours = true;

            try {
                const response = await fetch(`/umbraco/api/branchApi/GetBranchOpeningHours?dealerId=${dealerId}`);

                if (response.status != 200) {
                    const error = new Error("No opening hours for branch.");
                    error.status = response.status;
                    throw error;
                }

                const data = await response.json();

                if (data) {
                    if (isSettingDefault) {
                        vm.vehicleBranchOpeningHours = data;
                    }
                    vm.openingHours = data;

                    if (adjustBorders) {
                        vm.setDateTimeBorders(true);
                    }

                    vm.isLoadingOpeningHours = false;

                    return true;
                }


            } catch (error) {
                console.log(error);
                vm.isLoadingOpeningHours = false;
                return false;
            }
            return false;
        },
        handleConsentChanged(consent) {
            this.marketingConsent = consent;
        },
        setDateTimeBorders(setMinimumsOnOrder = false) {
            const vm = this;
            const nowDate = new Date();

            if (vm.order.date) {
                let currentDate = vm.order.date;
                const weekday = currentDate.getDay();
                const currentOpeningHours = vm.formattedOpeningHours?.find(x => x.date.getDate() == currentDate.getDate() && x.date.getMonth() == currentDate.getMonth() && x.date.getFullYear() && currentDate.getFullYear());

                if (currentDate.getDate() == nowDate.getDate() && currentDate.getMonth() == nowDate.getMonth() && currentDate.getFullYear() && nowDate.getFullYear()) {
                    currentDate = new Date();
                    //The selected date is today
                    if (nowDate.getHours() < currentOpeningHours.minTimeHours) {
                        //Before opening
                        vm.minTime = new Date(currentDate);
                        vm.minTime.setHours(currentOpeningHours.minTimeHours, currentOpeningHours.minTimeMinutes, 0);
                    } else {
                        //Close to closing
                        if (nowDate.getHours() >= currentOpeningHours.maxTimeHours - 2) {
                            vm.minTime = new Date(currentDate);
                            vm.minTime.setHours(currentOpeningHours.maxTimeHours, currentOpeningHours.maxTimeMinutes, 59);
                        } else {
                            //Through the day
                            vm.minTime = new Date(currentDate.getTime() + (2 * 60 * 60 * 1000));
                        }
                    }
                    vm.maxTime = new Date(currentDate);
                    vm.maxTime.setHours(currentOpeningHours.maxTimeHours - 1, currentOpeningHours.maxTimeMinutes, 59);
                } else {
                    //The selected date is something else
                    vm.minTime = new Date(currentDate);
                    vm.minTime.setHours(currentOpeningHours.minTimeHours, currentOpeningHours.minTimeMinutes, 0);

                    vm.maxTime = new Date(currentDate);
                    vm.maxTime.setHours(currentOpeningHours.maxTimeHours - 1, currentOpeningHours.maxTimeMinutes, 59);
                }
            } else {

                //Finding the first open day
                const currentOpeningHours = vm.formattedOpeningHours?.find(x => !x.isClosed);

                vm.minDate = new Date(currentOpeningHours.date.getTime() + (2 * 60 * 60 * 1000)); //Setting the minimum time to be two hours in the future
                vm.maxDate = new Date(currentOpeningHours.date.getFullYear(), currentOpeningHours.date.getMonth(), currentOpeningHours.date.getDate() + 6); //Setting the max time to be one week in the future
            }

            if (setMinimumsOnOrder) {
                vm.order.date = vm.minDate;
                vm.order.time = vm.minDate;
            }
        },
        handlePersonalInformationUpdate(response) {
            const vm = this;
            vm.order.firstName = response.info.firstName;
            vm.order.lastName = response.info.lastName;
            vm.order.email = response.info.email;
            vm.order.phone = response.info.phone;
            vm.order.address = response.info.address;
            vm.order.country = response.info.country;
            vm.order.city = response.info.city;
            vm.order.zipCode = response.info.zipCode;
            vm.order.personalInformationValid = response.isValid;
        },
        endFlow() {
            this.showSidebar = false;
            this.resetFlow();
        },
        resetFlow() {
            const vm = this;
            vm.order = {
                location: {},
                date: vm.minDate,
                time: vm.minDate,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                address: null,
                country: null,
                city: null,
                zipCode: null,
                personalInformationValid: false,
            }
            vm.consent = false;
            vm.branch = null;
            vm.isSubmitted = false;
            vm.currentStep = 0;
        },
        submitLead() {
            const vm = this;
            vm.toggleSpinner(true);
            const formData = new FormData();
            formData.append('LeadSourceUrl', window.location.href);
            formData.append('ModelBrand', vm.vehicle.BrandAlias);
            formData.append('ModelName', `${vm.vehicle.ModelName} ${vm.vehicle.ModelTrim}`);
            formData.append('ModelId', vm.vehicle.Id);
            formData.append('Vin', vm.vehicle.Vin);
            formData.append('FirstName', vm.order.firstName);
            formData.append('LastName', vm.order.lastName);
            formData.append('Email', vm.order.email);
            formData.append('Phone', vm.order.phone);

            if (vm.order.date) {
                const date = new Date(vm.order.date.getFullYear(), vm.order.date.getMonth(), vm.order.date.getDate(),
                    vm.order.time.getHours(), vm.order.time.getMinutes(), vm.order.time.getSeconds());
                formData.append('DesiredDateTime', date.toJSON());
            }

            if (vm.order.location != null) {
                if (vm.order.location.id == FlowConstants.testDriveOnLocation) {
                    formData.append('DealerId', vm.vehicle.DealerId);
                    formData.append('SecondaryDealerKey', vm.vehicle.SecondaryDealerKey);
                    formData.append('DealerBrand', vm.vehicle.DealerBrand);
                }
                if (vm.order.location.id == FlowConstants.testDriveAtShop) {
                    formData.append('DealerId', vm.order.location.value.shops.join(','));
                }
            } else {
                //Fallback if something goes totally wrong.
                formData.append('DealerId', vm.vehicle.DealerId);
                formData.append('SecondaryDealerKey', vm.vehicle.SecondaryDealerKey);
                formData.append('DealerBrand', vm.vehicle.DealerBrand);
            }


            const comment = []

            if (vm.order.street != null) {
                comments.push(`Street: ${vm.order.street}`);
            }
            if (vm.order.zipCode != null) {
                comment.push(`PostalCode: ${vm.order.zipCode}`);
            }
            if (vm.order.city != null) {
                comment.push(`City ${vm.order.city}`);
            }
            if (vm.order.country != null) {
                comment.push(`Country ${vm.order.country}`);
            }


            formData.append('Comment', comment.join('\n'));

            Recaptcha.GetToken('testdriveVehicleFlow', (token) => {
                formData.append('RecaptchaToken', token);
                fetch("/umbraco/api/leadsApi/PostCreateTestDriveRequest", {
                    method: "POST",
                    body: formData
                }).then(data => {
                    if (data.status == 200) {

                        //If the lead was submitted, let's submit the marketing consent
                        if (vm.marketingConsent) {
                            const consentPostModel = {
                                firstName: vm.order.firstName,
                                lastName: vm.order.lastName,
                                email: vm.order.email,
                                brand: vm.marketingConsent.brand,
                                consentTextId: vm.marketingConsent.consentTextId,
                                shopId: vm.marketingConsent.shopId
                            };

                            fetch('/umbraco/api/consentApi/createCustomerConsent', {
                                method: 'post',
                                headers: {
                                    "Content-Type": "application/json",
                                    "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                                },
                                body: JSON.stringify(consentPostModel)
                            });
                            //We fail or succeed silently, as failed newsletter signup aint as severe as a failed lead.
                            //Errors are logged in Umbraco anyways
                        }

                        vm.isSubmitted = true;
                        vm.changeStep(true);
                    } else {
                        vm.$toast.add({ severity: 'error', summary: vm.dictionary.vehicleFlowCommonSubmitErrorTitle, detail: vm.dictionary.vehicleFlowCommonSubmitErrorText, life: 10000 });
                    }

                    vm.toggleSpinner(false);
                }).catch(error => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
            });



        },
        changeStep(forward) {
            const vm = this;
            if (forward) {
                if (vm.currentStep == 1) {
                    if (!vm.order.personalInformationValid) {
                        vm.$toast.add({ severity: 'error', summary: vm.dictionary.vehicleFlowCommonPersonalDetailMissingErrorTitle, detail: vm.dictionary.vehicleFlowCommonPersonalDetailMissingErrorText, life: 10000 });
                        return false;
                    }
                }
                if (vm.currentStep == 2 && !vm.isSubmitted) {
                    vm.submitLead();
                    return false;
                }
                vm.currentStep++;
            } else {
                vm.currentStep--;
            }
            VueHelpers.updateQueryString(FlowConstants.flowStepQueryKey, this.steps[this.currentStep].queryAlias, false);

            VueHelpers.scrollToTopOfFlow();
        },
        async handleChangeBranch(branch) {
            const vm = this;
            console.log(branch);
            if (branch && branch.shops.length) {
                vm.branch = branch;
                this.order.location.value = branch;

                await vm.getOpeningHours(branch.shops[0], false, false);

            } else {
                vm.order.location.value = null;
                vm.openingHours = vm.vehicleBranchOpeningHours;
            }

            if (vm.openingHours != null) {
                vm.order.date = null;
                vm.order.time = null;
                vm.setDateTimeBorders(true);
            }

        },
        handleLocationChange(location) {
            const vm = this;
            vm.order.location = location;
            vm.order.location.value = null;
            switch (location.id) {
                case FlowConstants.testDriveOnLocation:
                    vm.branch = null;
                    vm.openingHours = vm.vehicleBranchOpeningHours;
                    break;
                default:
                    vm.openingHours = null;
                    break;
            }

            if (vm.openingHours != null) {
                vm.order.date = null;
                vm.order.time = null;
                vm.setDateTimeBorders(true);
            }
        },
        initFlow() {
            this.showSidebar = true;
            VueHelpers.updateQueryString(FlowConstants.flowNameQueryKey, this.flowName, false);
            VueHelpers.updateQueryString(FlowConstants.flowStepQueryKey, this.steps[this.currentStep].queryAlias, false);

        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;

            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        personalInformation() {
            return {
                firstName: this.order.firstName,
                lastName: this.order.lastName,
                email: this.order.email,
                phone: this.order.phone,
                address: this.order.address,
                country: this.order.country,
                city: this.order.city,
                zipCode: this.order.zipCode
            }
        },
        formattedOpeningHours() {
            if (this.openingHours != null) {

                return this.openingHours.map(x => {
                    return {
                        date: new Date(x.rawDate),
                        minTimeHours: x.from ? parseInt(x.from.substring(0, 3)) : 0,
                        minTimeMinutes: x.from ? parseInt(x.from.substring(3)) : 0,
                        maxTimeHours: x.to ? parseInt(x.to.substring(0, 3)) : 0,
                        maxTimeMinutes: x.to ? parseInt(x.to.substring(3)) : 0,
                        isClosed: x.isClosed
                    }
                });
            }

            return null;
        }
    }
};
</script>
